import { lazy, type ReactElement } from 'react';

export interface RemoteAccessRouteDefinition {
  capabilityPath: string;
  label: string;
  element: ReactElement;
}

export const RecordingPlayer = lazy(() =>
  import('./components/RecordingPlayer').then((module) => ({
    default: module.RecordingPlayer,
  }))
);

export const RecordingsList = lazy(() => import('./pages/RecordingsList'));

export const RecordingPlayback = lazy(() => import('./pages/RecordingPlayback'));

export const REMOTE_ACCESS_ROUTE_DEFINITIONS: readonly RemoteAccessRouteDefinition[] = [
  {
    capabilityPath: '/remote/recordings',
    label: 'Recordings List',
    element: <RecordingsList />,
  },
  {
    capabilityPath: '/remote/recordings/:recordingId',
    label: 'Recording Player',
    element: <RecordingPlayer />,
  },
];
